import { MouseEvent } from "react";
import ReactPlayer from "react-player";
import Button from "components/Elements/Button/Button";
import { useContent } from "contexts/contentContext/contentContext";

const FormsNoDataMessage = () => {
  const { getTextByKey, getLanguage } = useContent();
  const youtubeLink =
    getLanguage() === "he"
      ? "https://www.youtube.com/embed/zJtaksPhTZE"
      : "https://www.youtube.com/embed/Oty4U4WAww0";

  const handleClick = (e: MouseEvent) => {
    e.preventDefault();
    window.open("https://www.jumbomail.me/en/jumbo-forms", "_blank");
  };

  return (
    <div className="no-forms-data-wrapper">
      <div className="content">
        <h1>{getTextByKey("jumboform-no-data-title")}</h1>
        <h2>{getTextByKey("jumboform-no-data-sub-title")}</h2>
        <p>{getTextByKey("jumboform-no-data-sub-description")}</p>
        <div className="player-wrapper">
          <ReactPlayer
            url={youtubeLink}
            controls={false}
            width={472}
            height={266}
          />
        </div>
        <a
          href="https://www.jumbomail.me/en/jumbo-forms"
          onClick={(e) => handleClick(e)}
        >
          <Button buttonClass="lear-more-button">
            {getTextByKey("jumboform-learn-more")}
          </Button>
        </a>
      </div>
    </div>
  );
};

export default FormsNoDataMessage;
